const Stores = () => import('@/modules/stores/index.vue');
const FranchisorStores = () => import('@/modules/stores/_components/FranchisorStoreList/index.vue');

export default [
  {
    path: '/lojas',
    name: 'list-stores',
    component: FranchisorStores,
    meta: {
      drawerComponent: () => import('@/modules/store/_components/StoreDuplicationFormBase'),
      navbarTitle: 'Lojas',
      isAvaliableInMenu: true,
      nameCity: true,
      menuData: {
        title: 'Lojas',
        id: 'storesSidebar',
        icon: 'store-2',
        section: 'Operação',
      },
    },
  },
  {
    path: '/lojas/criar',
    name: 'stores-create',
    component: Stores,
    meta: {
      checkBeforeRedirect: true,
      navbarTitle: 'Criar loja',
    },
  },
  {
    path: '/lojas/relatorios',
    name: 'store-reports',
    component: Stores,
    meta: {
      navbarTitle: 'Lojas',
      nameCity: true,
    },
  },
  {
    path: '/lojas/operador-logistico/:logisticOperatorId',
    name: 'list-logistic-operator-stores',
    props: true,
    component: Stores,
    meta: {
      navbarTitle: 'Lojas',
    },
  },
];
